import type { SupStoredFavToken, Networkish } from "@/types";
import React, { useMemo } from "react";

import { SupIconButton } from "@repo/core-ui";
import { checkFavToken, useStoredData, useStoredDataDispatch } from "@/store/Context";
import { SupPin } from "@repo/core-ui";

interface GridCellPinTokenProps {
  singleBalance: {
    chainId: Networkish;
    address: string;
    symbol: string;
  };
}

export default function GridCellPinToken({ singleBalance }: GridCellPinTokenProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const { isPinned, balanceToken } = useMemo(() => {
    const balanceToken = {
      chainId: singleBalance.chainId,
      tokenAddress: singleBalance.address,
      tokenSymbol: singleBalance.symbol,
    } as SupStoredFavToken;
    return {
      isPinned: checkFavToken(storedData.favTokens, balanceToken),
      balanceToken,
    };
  }, [singleBalance.address, singleBalance.chainId, singleBalance.symbol, storedData.favTokens]);
  const handleTokenPin = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
    storedDispatch({ type: "toggleFavTokens", favToken: balanceToken });
    return false;
  };

  return (
    <SupIconButton onClick={handleTokenPin} className="max-w-[30px] cursor-pointer text-primary-500" active={isPinned} activeClassName="fill-neutral-200">
      <SupPin />
    </SupIconButton>
  );
}
